import { render, staticRenderFns } from "./PageEmployeePosition.vue?vue&type=template&id=8536e37a&"
import script from "./PageEmployeePosition.vue?vue&type=script&lang=js&"
export * from "./PageEmployeePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports